<header class="site-header" [style.width]="headerSettings?.headerWidth">
  <a class="brand" href="#home" (click)="$event.preventDefault(); selectSection('home')" aria-label="DySi home">
    @if (headerSettings?.logoUrl) {
    <img [src]="headerSettings?.logoUrl" [alt]="headerSettings?.logoAlt || 'Logo'"
      [style.width]="headerSettings?.logoWidth" [style.height]="headerSettings?.logoHeight" class="brand__logo" />
    } @else {
    <span class="brand__mark">{{ (headerSettings?.websiteName || 'DySi').charAt(0) }}</span>
    }
    <span>{{ headerSettings?.websiteName || 'DySi' }}</span>
  </a>

  <nav *ngIf="showTopNavMenu" class="nav" [class.nav--open]="isMenuOpen()" aria-label="Primary navigation">
    @for (item of menus; track item.id || item.sectionId) {
    <a href="#{{ item.sectionId }}" [class.active]="activeSection === item.sectionId"
      (click)="$event.preventDefault(); selectSection(item.sectionId)">
      {{ item.title }}
    </a>
    }
    @if (isAdmin) {
    <a routerLink="/admin" class="admin-link" (click)="isMenuOpen.set(false)">Admin</a>
    }
    @if (isSuperAdmin) {
    <a routerLink="/super-admin" class="super-admin-link" (click)="isMenuOpen.set(false)">Super Admin</a>
    }
    
    @if (user$ | async; as user) {
      <div class="user-profile-nav">
        <img [src]="user.photoURL || 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y'" class="user-avatar-nav" alt="Avatar" />
        <span class="user-name-nav">{{ user.displayName || user.email }}</span>
        <button class="btn-auth-logout-nav" (click)="websiteData.signOut(); isMenuOpen.set(false)">Sign Out</button>
      </div>
    } @else {
      <a routerLink="/admin" class="admin-link auth-login-link" (click)="isMenuOpen.set(false)">Sign In</a>
    }
  </nav>

  <div class="header-actions">
    <div class="search" [class.search--open]="isSearchOpen()">
      @if (isSearchOpen()) {
      <input type="search" placeholder="Search menu" [value]="searchTerm()"
        (input)="searchTerm.set($any($event.target).value)" />
      <div class="search__results">
        @for (item of filteredMenus(); track item.id || item.sectionId) {
        <button type="button" (click)="selectSection(item.sectionId)">{{ item.title }}</button>
        }
      </div>
      }
      <button class="theme-toggle" type="button" aria-label="Search menu" (click)="isSearchOpen.set(!isSearchOpen())">
        <i class="fa-solid fa-magnifying-glass"></i>
      </button>
    </div>
    <button class="theme-toggle" type="button" aria-label="Toggle theme" (click)="themeToggled.emit()">
      <i class="fa-solid" [class.fa-moon]="!isDarkTheme" [class.fa-sun]="isDarkTheme"></i>
    </button>
    <button *ngIf="showTopNavMenu" class="menu-toggle" type="button" aria-label="Toggle menu"
      [attr.aria-expanded]="isMenuOpen()" (click)="isMenuOpen.set(!isMenuOpen())">
      <i class="fa-solid" [class.fa-bars]="!isMenuOpen()" [class.fa-xmark]="isMenuOpen()"></i>
    </button>
  </div>
</header>